import type { AssetWorkflowOptions } from '../../types';

export const editReturnToAddressOverridesWorkflow: AssetWorkflowOptions = {
  workflowKey: 'editReturnToAddressOverridesWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'returnAddressOverride',
  workflowIndex: 1,
  workflowName: 'Edit Return To Address Override',
  workflowDescription:
    'Edit a return to address override. This will override the normal return address configured for the specified origin.',
  workflowStateTransformFunction: (assetPayload: any) => {
    return {
      ...assetPayload,
    };
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Unique Identifier',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this return to address override',
        description: 'This is optional but will allow you to more easily reference this return to address override',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'Enter a name for this return to address override',
        description: 'How will you refer to this return to address override',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a description of this return to address override',
        description: '',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'returnToAddress',
      workflowStepNavigationName: 'Return To Address',
      workflowComponent: {
        workflowComponentType: 'addressEntry',
        description: 'Select or create an address for this return to address override',
        prompt: '',
        help: '',
      },
      assetToWorkflowStateMapping: {
        assetProperty: 'addressId',
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'address',
        list: true,
      },
    },
    {
      workflowStepKey: 'contact',
      workflowStepNavigationName: 'Contacts',
      workflowComponent: {
        workflowComponentType: 'contactEntry',
        description: 'Select or create a contact for this return to address override',
        prompt: '',
        help: '',
      },
      assetToWorkflowStateMapping: {
        assetProperty: 'contactId',
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'contact',
        list: true,
      },
    },
    {
      workflowStepKey: 'carrierSelect',
      workflowStepNavigationName: 'Carriers',
      workflowComponent: {
        singleSelect: false,
        hideServiceMethods: true,
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which carrier does this return to address override apply to?',
        description: '',
        help: `If you don't see your carrier here please contact a shipium admin `,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrierIds',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this return to address override belong to a specific tenant?',
        description: '',
        help: '',
        optional: true,
      },
      calculatedComponentProps: {
        assetId: {
          type: 'asset',
          property: 'carrierRateId',
        },
      },
      optional: true,
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Edit Return To Address Override Summary',
        description: 'The return to address override will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
